export const BACKSPACE = 8;
export const DELETE = 46;
export const DOWN_ARROW = 40;
export const ENTER = 13;
export const LEFT_ARROW = 37;
export const RIGHT_ARROW = 39;
export const TAB = 9;
export const UP_ARROW = 38;
